export default "__VITE_ASSET__Bb7SSloT__"